import React from 'react';
import { Table } from 'react-bootstrap';
import Event from '../../objects/Event';
import Location from '../../objects/Location';
import moment from 'moment';
import Cart, { Reservation } from '../../objects/Cart';
import './minicalendar.scss';

interface MiniCalendarEventsProps {
    events: Event[]
    locations: Location[]
    cart?: Cart
    eventClickHandler: (event: FatEvent) => void
}

interface Month {
    i: number
    name: string
}

export interface FatEvent {
    month_number: number
    year: number
    day: number
    localization: number
    event: Event
}

interface MiniCalendarState {
    events_by_month: FatEvent[]
    current_month: number
}

const months: Month[] = [
    { i: 1, name: 'Styczeń' },
    { i: 2, name: 'Luty' },
    { i: 3, name: 'Marzec' },
    { i: 4, name: 'Kwiecień' },
    { i: 5, name: 'Maj' },
    { i: 6, name: 'Czerwiec' },
    { i: 7, name: 'Lipiec' },
    { i: 8, name: 'Sierpień' },
    { i: 9, name: 'Wrzesień' },
    { i: 10, name: 'Październik' },
    { i: 11, name: 'Listopad' },
    { i: 12, name: 'Grudzień' },
]

const month_show_count: number = 3;

export class MiniCalendar extends React.Component<MiniCalendarEventsProps, MiniCalendarState> {

    state = {
        current_month: moment().month() + 1,
        events_by_month: [],
    }

    constructor(props: any) {
        super(props);
    }

    componentWillReceiveProps(nextProps: any): void {
        if (this.props === nextProps) {
            return;
        }
        this.setState({ events_by_month: this.mapEventsToFatEvents(nextProps.events) })
    }

    private mapEventsToFatEvents = (events: Event[]): FatEvent[] => {
        let converted = new Array<FatEvent>();
        events.map((event: Event) => {
            let month: number = moment.unix(event.start_time).toDate().getMonth() + 1;
            let year: number = moment.unix(event.start_time).toDate().getFullYear();
            let day: number = parseInt(moment.unix(event.start_time).format('D'))
            converted.push({ month_number: month, event: event, year: year, localization: event.localization, day: day });
        })
        return converted;
    }

    private getEventsForLocalizationAndMonth = (localization: number, month: number): FatEvent[] => {
        return this.state.events_by_month.filter((event: FatEvent) => {
            return event.localization == localization && event.month_number == month + 1
        })
    }

    private renderEventsLabelsFromFatEvent = (event: FatEvent): JSX.Element => {
        let isPast: boolean = moment.unix(event.event.start_time).isSameOrBefore(moment())
        let isReserved: boolean = (this.props.cart instanceof Cart) ? this.props.cart.cart.filter((r: Reservation) => r.event_id == event.event.id).length > 0 : false
        let cls = "minicalendar-day " + (isPast ? "expired" : isReserved ? "minicalendar-reserved" : "")
        return (<div className={cls} onClick={() => this.props.eventClickHandler(event)}>{moment.unix(event.event.start_time).format('DD')}</div>)
    }

    private getAllLocalizationIdsForEvents = (): number[] => {
        let ids: number[] = new Array<number>();
        this.state.events_by_month.forEach((e: FatEvent) => {
            ids.push(e.localization);
        })
        return ids.filter(function (value: number, index: number, self: Array<number>) {
            return self.indexOf(value) === index;
        });
    }

    private putHeading = (): JSX.Element => {
        let { current_month } = this.state;

        return (
            <thead>
                <tr>
                    {this.putMonthsHeading(current_month)}
                </tr>
            </thead>
        )
    }

    private populateTable = (): any => {
        let start_month: number = this.determineValidStartingMonth(this.state.current_month);

        if (this.props.events.length == 0) {
            return <td colSpan={4}>Brak dostępnych kursów w wybranym terminie</td>
        }

        return this.getAllLocalizationIdsForEvents().map((localization: number, index: number) => {
            let children: JSX.Element[] = new Array<JSX.Element>();

            for (let i = start_month; i < start_month + month_show_count; i++) {
                let events: Array<FatEvent> = this.getEventsForLocalizationAndMonth(localization, i);
                interface DayEventMap {
                    event: FatEvent;
                }
                //show single days
                let dayEventsMap: Array<DayEventMap> = []
                events.map((event: FatEvent) => dayEventsMap[event.day] = { event: event })
                dayEventsMap = dayEventsMap.filter(function (value: DayEventMap, index: number, self: Array<DayEventMap>) {
                    return self.indexOf(value) === index;
                });
                children.push(
                    <td>
                        <div className="minicalendar-month">
                            {dayEventsMap.map((event: DayEventMap) => {
                                return this.renderEventsLabelsFromFatEvent(event.event)
                            })}</div></td>);
            }

            return (<tr key={index}>
                <td>{this.getLocalizationById(localization).city}</td>
                {children.map((c: JSX.Element) => {
                    return c
                })}
            </tr>);
        })
    }

    private determineValidStartingMonth = (month: number): number => {
        return month == 1 ? 1 : (month - 1)
    }

    private getLocalizationById = (id: number): Location => {
        return this.props.locations.filter((l: Location) => l.id == id)[0]
    }

    private putMonthsHeading = (current_month: number): any => {
        let start_month: number = this.determineValidStartingMonth(current_month);

        let heading: JSX.Element[] = new Array<JSX.Element>(<td>Lokalizacja</td>);
        for (let i = start_month; i < start_month + month_show_count; i++) {
            heading.push(<th>{months[i].name}</th>)
            if (i == 12) {
                i = 1;
                start_month = start_month + 1;
            }
        }
        return heading;
    }

    render(): any {
        return (<div>
            <h5>{this.props.events[0]?.course_name ?? 'Nie znaleziono kursów w najbliższym czasie'}</h5>
            <Table striped bordered hover className="miniCalendar">
                {this.putHeading()}
                <tbody>
                    {this.populateTable()}
                </tbody>
            </Table>
        </div>
        )
    }
}